import { render } from "./HormoneReplacementContentEn.vue?vue&type=template&id=e2a3a6a8"
import script from "./HormoneReplacementContentEn.vue?vue&type=script&lang=js"
export * from "./HormoneReplacementContentEn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__